export default __webpack_public_path__ + "img/3-1-a5c3ead3.png";